"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getDatesOfDateRange_1 = require("../Util/getDatesOfDateRange");
class TrainingCache {
    constructor(compositeCache, cache, networkFirstStrategy) {
        this.compositeCache = compositeCache;
        this.cache = cache;
        this.networkFirstStrategy = networkFirstStrategy;
        this.getDay = async (date, userId, getRequest) => {
            return await this.cache.get(`TRAINING.DAY.${date}.${userId}`, getRequest);
        };
        this.getRange = async (range, userId, getRequest) => {
            const keys = (0, getDatesOfDateRange_1.getDatesOfDateRange)(range).map((date) => `TRAINING_DATE_RANGE.${userId}.${date}`);
            return this.compositeCache.get(keys, getRequest, this.denormalized(userId), this.normalized);
        };
        this.getTrainingsPerWeek = async (userId, date, getRequest) => {
            return await this.networkFirstStrategy.get(`TRAININGS_PER_WEEK.${userId}.${date}`, getRequest);
        };
        this.denormalized = (userId) => (denormalized) => {
            const map = new Map();
            denormalized.days.forEach((day) => {
                map.set(`TRAINING_DATE_RANGE.${userId}.${day.date}`, day);
            });
            return map;
        };
        this.normalized = (normalized) => {
            return {
                days: [...normalized.values()],
            };
        };
    }
}
exports.default = TrainingCache;
//# sourceMappingURL=TrainingCache.js.map